var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.tableShow === "carTeam" ? _c("carTeamTable", {
    on: {
      "child-go": _vm.goChild
    }
  }) : _vm._e(), _vm.tableShow === "driverTable" ? _c("driverTable", {
    attrs: {
      currentCarTeam: _vm.currentCarTeam
    },
    on: {
      "child-go-car-team": _vm.goCarTeam
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };